import { LOCAL_STORAGE_KEY } from './constants';
import { isAvailable } from './isAvailable';

export function isViewed(cianId: number = -1): boolean {
  if (!isAvailable()) {
    return false;
  }

  const viewedClusters = localStorage.getItem(LOCAL_STORAGE_KEY)?.split(',') || [];

  return viewedClusters.some(viewedCianId => cianId === +viewedCianId);
}
